import React from 'react'
import { Dot } from 'react-bootstrap-icons'

const Day = ({
    children,
    onClick = () => {},
    disabled,
    dateLabelColor,
    dateDotColor,
    dateBackgroundColor
}) => {

    const onClicked = React.useCallback(() => {
        if (!disabled) {
            onClick()
        }
    }, [onClick, disabled])

    const boxStyle = {
        minWidth: '40px',
        width: '40px',
        minHeight: '40px',
        height: '40px',
        cursor: 'pointer',
        borderRadius: '20px',
        margin: 'auto',
        color: 'rgb(187, 187, 187)',
    }

    const dotStyle = {
        position: 'relative',
        bottom: '10px',
        color: 'rgb(38, 153, 251)',
    }

    /*
    if (color) {
        dotStyle.color = color
    } else {
        dotStyle.display = 'none'
    }

    if (today) {
        boxStyle.backgroundColor = 'rgb(187, 187, 187)'
        boxStyle.border = '1px solid rgb(187, 187, 187)'
        boxStyle.color = 'white'
    }

    if (selected) {
        boxStyle.backgroundColor = 'rgb(38, 153, 251)'
        boxStyle.border = '1px solid rgb(38, 153, 251)'
        boxStyle.color = 'white'
    }

    if (selected && color) {
        boxStyle.backgroundColor = color
        boxStyle.border = '1px solid ' + color
        dotStyle.color = 'white'
    }

    if (!selected && color) {
        boxStyle.color = 'black'
    }
    */

    boxStyle.color = dateLabelColor
    if (dateBackgroundColor) {
        boxStyle.backgroundColor = dateBackgroundColor
        boxStyle.border = `1px solid ${dateBackgroundColor}`
    }
    if (dateDotColor) {
        dotStyle.color = dateDotColor
    } else {
        dotStyle.display = 'none'
    }

    return (
        <div 
            className='text-center'
            onClick={onClicked}
            style={boxStyle}
        >
            <div>{children}</div>
            <div style={dotStyle} >
                <Dot size={30} />
            </div>
            
        </div>
    )
}

export default Day